/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
} from './Tournament';

/**
 * 
 * @export
 * @interface PaginatedTournamentList
 */
export interface PaginatedTournamentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTournamentList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTournamentList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTournamentList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Tournament>}
     * @memberof PaginatedTournamentList
     */
    results?: Array<Tournament>;
}

/**
 * Check if a given object implements the PaginatedTournamentList interface.
 */
export function instanceOfPaginatedTournamentList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginatedTournamentListFromJSON(json: any): PaginatedTournamentList {
    return PaginatedTournamentListFromJSONTyped(json, false);
}

export function PaginatedTournamentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedTournamentList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(TournamentFromJSON)),
    };
}

export function PaginatedTournamentListToJSON(value?: PaginatedTournamentList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(TournamentToJSON)),
    };
}

